import { PortfoliosStore } from '.';
import { RootState } from '../..';

export const selectPortfolios = (state: RootState): PortfoliosStore => state.portfolios;
